import EventEmitter from 'eventemitter3';

import {FilterDialogSectionId} from 'filters/features/FilterDialog/types';

type EventTypes = Record<`open/${string}`, (section?: FilterDialogSectionId) => void>;

export const dialogEmitter = new EventEmitter<EventTypes>();

/**
  @id - empty string for global dialog, or specific id for distinguishing multiple dialogs
 */
export const openFilterDialog = (section?: FilterDialogSectionId, id?: string) =>
  dialogEmitter.emit(`open/${id}`, section);
